export default __webpack_public_path__ + "static/tiempos-text-web-medium-f0a4f12bb8ac730ac1032f6a7e2f7b46.eot";